import { render, staticRenderFns } from "./Competitor.vue?vue&type=template&id=307abf6d&scoped=true&"
import script from "./Competitor.vue?vue&type=script&lang=js&"
export * from "./Competitor.vue?vue&type=script&lang=js&"
import style0 from "./Competitor.vue?vue&type=style&index=0&id=307abf6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307abf6d",
  null
  
)

/* custom blocks */
import block0 from "./Competitor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports